import { render, staticRenderFns } from "./M2hAccountSetup.vue?vue&type=template&id=454a2e6c&scoped=true&"
import script from "./M2hAccountSetup.vue?vue&type=script&lang=js&"
export * from "./M2hAccountSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a2e6c",
  null
  
)

export default component.exports